import { getRequestAPI, putRequestAPI } from "../utils/apiCalls";

const IP_URL = process.env.REACT_APP_NODE_API_URL

export async function getEquipments() {
  const response = await getRequestAPI('database-equipments');
  return response;
}

export async function getGpsGateTags() {
  const response = await getRequestAPI('gps-gate-tags');
  return response;
}

export async function getGpsGateUsers() {
  const response = await getRequestAPI('gps-gate-users');
  return response;
}

export async function getGpsGateMainUsers() {
  const response = await getRequestAPI('gps-gate-users/main');
  return response;
}

export async function getGpsGateBackupUsers() {
  const response = await getRequestAPI('gps-gate-users/backup');
  return response;
}

export async function getLastReview() {
  const response = await getRequestAPI('database-health-review');
  return response;
}

export async function putLastReview(body) {
  const response = await putRequestAPI('database-health-review', body);
  return response;
}

export const getEquipmentsByType = async (equipment_types, application_id) => {
  try {
    const response = await fetch(
      IP_URL  + "database_all_equipments_by_id",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          equipment_groups_list: equipment_types,
        }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    //console.error("Error al iniciar sesión", error);
    var aux = 0;
  }
};

export const getEquipmentTypes = async () => {
  try {
    const response = await fetch(
      IP_URL  + "sm_26_equipment/get_equipment_types",
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
    const data = await response.json();
    console.log('Respuesta equipment: ', data);
    return data;
  } catch (error) {
    console.error("Respuesta equipment error", error);
    var aux = 0;
  }
};

export const getEquipmentModels = async (equipment_type_list) => {
  try {
      console.log('Cambio el equipmentTypeId 2', equipment_type_list)
    const response = await fetch(
      IP_URL  + "sm_26_equipment/get_equipment_model",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          equipment_type_list: equipment_type_list, 
        }),
      }
    );
    const data = await response.json();
    console.log('Respuesta equipment: ', data);
    return data;
  } catch (error) {
    console.error("Respuesta equipment Error: ", error);
    var aux = 0;
  }
};

export const getEquipmentOwner = async () => {
  try {
    const response = await fetch(
      IP_URL  + "sm_26_equipment/get_equipment_owner",
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
    const data = await response.json();
    console.log('Respuesta equipment: ', data);
    return data;
  } catch (error) {
    console.error("Respuesta equipment Error", error);
    var aux = 0;
  }
};

export const getAllEquipment= async (equipment_type_list, equipment_model_list, equipment_owner_list) => {
  try {
    const response = await fetch(
      IP_URL  + "sm_26_equipment/get_all_equipment",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          equipment_type_list: equipment_type_list, 
          equipment_model_list: equipment_model_list, 
          equipment_owner_list: equipment_owner_list
        }),
      }
    );
    const data = await response.json();
    console.log('Respuesta equipment All: ', data);
    return data;
  } catch (error) {
    console.error("Respuesta equipment All Error", error);
    var aux = 0;
  }
};


export const insertNewEquipment= async (equipmentInformation) => {
  try {
    const response = await fetch(
      IP_URL  + "sm_26_equipment/insert_equipment",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          equipment_id: equipmentInformation.equipmentId, 
          equipment_name: equipmentInformation.equipmentName, 
          equipment_type_id: equipmentInformation.equipmentTypeId.value,
          equipment_model_id: equipmentInformation.equipmentModelId.value,
          contractor_scgl: equipmentInformation.contractorScgl.value,
          equipment_owner: equipmentInformation.equipmentOwner.value,
        }),
      }
    );
    const data = await response.json();
    console.log('Respuesta equipment All: ', data);
    return data;
  } catch (error) {
    console.error("Respuesta equipment All Error", error);
    var aux = 0;
  }
};

export const deleteEquipment= async (equipmentInformation) => {
  try {
    const response = await fetch(
      IP_URL  + "sm_26_equipment/desactivate_equipment",
      {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          equipment_id: equipmentInformation.equipmentId, 
          is_last_day: equipmentInformation.isLastDay
        }),
      }
    );
    const data = await response.json();
    console.log('Respuesta equipment des: ', data);
    return data;
  } catch (error) {
    console.error("Respuesta equipment des Error", error);
    var aux = 0;
  }
};